import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileText, Download, ArrowRight } from 'lucide-react';
import { publications } from '../data/researchData';

export default function Publications() {
  const [activeCategory, setActiveCategory] = useState('All');
  const categories = ['All', 'Working Papers', 'Policy Briefs', 'Journal Articles'];

  const filteredPublications = activeCategory === 'All' 
    ? publications 
    : publications.filter(pub => pub.category === activeCategory);

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-900">Latest Publications</h2>
          <p className="mt-4 text-xl text-gray-600">
            Explore our research publications and findings
          </p>
        </motion.div>

        <div className="flex justify-center space-x-4 mb-12 overflow-x-auto pb-4">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors
                ${activeCategory === category 
                  ? 'bg-green-600 text-white' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPublications.map((pub, index) => (
            <motion.div
              key={pub.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl shadow-lg overflow-hidden group"
            >
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="bg-green-100 p-2 rounded-lg">
                    <FileText className="h-5 w-5 text-green-600" />
                  </div>
                  <span className="text-sm font-medium text-green-600">{pub.category}</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{pub.title}</h3>
                <p className="text-gray-600 mb-4">{pub.description}</p>
                <div className="flex justify-between items-center">
                  <button className="inline-flex items-center text-green-600 hover:text-green-700">
                    Read more
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </button>
                  <button className="inline-flex items-center text-gray-500 hover:text-gray-700">
                    <Download className="h-4 w-4 mr-1" />
                    PDF
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}